import React from 'react';

import PropTypes from 'prop-types';
import './ButtonBar.scss';

const ButtonBar = ({ children }) => {
	return (
		<div className='ButtonBar'>
			<div className='ButtonBar-wrapper'>
				<div className='bg-blur'>{children}</div>
			</div>
		</div>
	);
};

ButtonBar.propTypes = {
	children: PropTypes.node,
};

export default ButtonBar;
